export enum InspectionType {
	accepted = "accepted",
	rejected = "rejected",
}
